import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PanelService} from '../../../../admin/services/panel.service';
import {environment} from "../../../../../environments/environment";

@Component({
    selector: 'app-vpanel',
    templateUrl: './vpanel.component.html',
    styleUrls: ['./vpanel.component.css']
})
export class VpanelComponent implements OnInit {

    code;
    products: any[] = [];

    constructor(private route: ActivatedRoute, private panelService: PanelService, private router: Router) {
    }

    ngOnInit(): void {

        this.code = this.route.snapshot.paramMap.get('code');
        console.log(this.code);
        this.getPanelProducts(this.code);

    }

    getPanelProducts(code) {
        this.panelService.getPanelByCode(code).subscribe(response => {
            console.log('the result');
            console.log(response);
            this.products = response.products;
        });
    }

    goToProductDetails(sku) {
        this.router.navigateByUrl('product/360/details/' + this.code + "/" + sku);

    }

    getImage(image) {

        // const temp = image.split('');
        // console.log(temp);
        return "https://web.alarabiya.com.kw/pub/media/catalog/product/cache/89fe15788e0ddb13201fd7b32de9c9d8/"+image;
        //return environment.baseCatalogUrl + environment.baseImagePath + temp[0] + '/' + temp[1] + '/' + image + '.jpg';


    }

}
